import React from 'react';

import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { AccessPointData } from '../../api/types';
import { AccessPointCard } from '../AccessPointCard/AccessPointCard';
import { ScanButton } from '../ScanButton/ScanButton';
import { PermissionContent } from './PermissionContent';
import { PermissionsNotFound } from './PermissionsNotFound';

interface PermissionsProps {
    accessInformation: AccessPointData;
    permissionId?: string;
    translations: Record<string, string>;
}

export const Permissions: React.FC<PermissionsProps> = ({ accessInformation, permissionId, translations }) => {
    const permissionInfo = accessInformation.permissions.find(({ permissionCode }) => permissionCode === permissionId);
    if (!permissionInfo) {
        return <PermissionsNotFound accessPointCode={accessInformation.accessPointCode} translations={translations} />;
    }

    const location = useLocation();
    const displayScanButton =
        queryString.parse(location.search, {
            parseBooleans: true,
        }).scanbutton || false;

    const Button = displayScanButton ? <ScanButton translations={translations} isRescan /> : null;
    const backButtonUrl = !displayScanButton ? `/accesspoint/${accessInformation.accessPointCode}` : undefined;

    return (
        <AccessPointCard accessInformation={accessInformation} Button={Button} backButtonTo={backButtonUrl}>
            <PermissionContent
                accessInformation={accessInformation}
                permissionInfo={permissionInfo}
                readOnly={false}
                translations={translations}
            />
        </AccessPointCard>
    );
};
